export default __webpack_public_path__ + "static/logo-1010a340d13e479d96cf4610123d79ba.svg";